// pages/forms2/Forms2.jsx
import styles from "../../styles/Forms2.module.css";
import React from "react";
import LateralMenu from "../../components/LateralMenu/LateralMenu";
import { useContext, useEffect, useState } from "react";
import TextField from "@mui/material/TextField";
import DeleteIcon from '@mui/icons-material/Delete';
import SearchIcon from '@mui/icons-material/Search';
import FilterListIcon from '@mui/icons-material/FilterList';
import {
  IconButton,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  FormHelperText,
  Box,
  Container,
  Button,
  Typography,
  CircularProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  TableSortLabel,
  InputAdornment,
  Chip,
  Tooltip,
  Alert,
  Grid,
} from '@mui/material';
import * as XLSX from "xlsx";
import ButtonComp from "../../components/Button/Button";
import { authService } from "../../services/auth.service";
import { pesquisaApi } from "../../services/apiPesquisa.servise";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setHeader } from "../../store/reducers/dadosHeader";

export default function Forms() {
  const location = useLocation();
  const [roadName, setRoadName] = useState(location.state?.roadName || "");
  const [snippet, setSnippet] = useState(location.state?.snippet || "");
  const [initialKm, setInitialKm] = useState(0);
  const [arquivoRef, setArquivoRef] = useState(location.state?.arquivo || null);
  const [dataImport, setDataImport] = useState(null);

  const taskIdFromState = location.state?.taskId;
  const isFromProcessing = !!taskIdFromState;
  
  // Se veio do processamento, selecionar automaticamente o banco
  const [inputMethod, setInputMethod] = useState(isFromProcessing ? "database" : "upload");

  // Estados para paginação e filtros
  const [processedTasks, setProcessedTasks] = useState([]);
  const [loadingTasks, setLoadingTasks] = useState(false);
  const [loadingFile, setLoadingFile] = useState(false);
  const [selectedTaskId, setSelectedTaskId] = useState(taskIdFromState || "");
  const [selectedTask, setSelectedTask] = useState(null);

  // Estados para seleção de usuário
  const [users, setUsers] = useState([]);
  const [loadingUsers, setLoadingUsers] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [selectedUserId, setSelectedUserId] = useState(null);

  // Paginação
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalTasks, setTotalTasks] = useState(0);
  
  // Filtros
  const [searchText, setSearchText] = useState("");
  const [taskIdFilter, setTaskIdFilter] = useState("");
  const [showFilters, setShowFilters] = useState(false);
  
  // Ordenação
  const [orderBy, setOrderBy] = useState('created_at');
  const [order, setOrder] = useState('desc');
  
  const navigate = useNavigate();
  const dispacth = useDispatch();

  // Carregar usuários
  const loadUsers = async () => {
    setLoadingUsers(true);
    try {
      const response = await pesquisaApi.getUsers();
      if (response && response.data && response.data.results) {
        setUsers(response.data.results);
        
        // Se estiver logado, definir o usuário atual como padrão
        const loggedUserId = await authService.getLoggedUserId();
        const currentUser = response.data.results.find(user => user.id === loggedUserId);
        if (currentUser) {
          setSelectedUser(currentUser);
          setSelectedUserId(currentUser.id);
        }
      }
    } catch (error) {
      console.error("Erro ao carregar usuários:", error);
      setUsers([]);
    } finally {
      setLoadingUsers(false);
    }
  };

  // Carregar tarefas com paginação e filtros
  const loadProcessedTasks = async (pageNum = 0, search = "", filters = {}) => {
    if (inputMethod !== "database") return;
    
    setLoadingTasks(true);
    try {
      const filtersToApply = {
        ...filters,
        ordering: order === 'desc' ? `-${orderBy}` : orderBy
      };
      
      const result = await pesquisaApi.getProcessedTasks(
        pageNum + 1,
        rowsPerPage,
        search,
        filtersToApply
      );
      
      setProcessedTasks(result.tasks || []);
      setTotalTasks(result.pagination?.count || 0);
      
      console.log(`📊 ${result.tasks.length} tarefas carregadas, total: ${result.pagination?.count}`);
    } catch (error) {
      console.error("Erro ao carregar tarefas:", error);
      setProcessedTasks([]);
      setTotalTasks(0);
    } finally {
      setLoadingTasks(false);
    }
  };

  useEffect(() => {
    if (!selectedUserId){      
      loadUsers();
    }
    
    if (inputMethod === "database") {
      const filters = {};
      if (taskIdFilter) filters.taskId = taskIdFilter;
      loadProcessedTasks(page, searchText, filters);
    }
    if (taskIdFromState && inputMethod === "database") {
      console.log(`🚀 Carregando automaticamente tarefa ${taskIdFromState} do processamento`);
      
      loadProcessedTasks(0, "", {}).then(() => {
        if (taskIdFromState) {
          setTimeout(() => {
            const taskData = processedTasks.find(t => t.task_id == taskIdFromState);
            if (taskData) {
              loadPlanilhaFromDatabase(taskIdFromState, taskData);
            } else {
              buscarTarefaEspecifica(taskIdFromState);
            }
          }, 500);
        }
      });
    }
  }, [inputMethod, page, rowsPerPage, orderBy, order, taskIdFromState]);

  const buscarTarefaEspecifica = async (taskId) => {
    try {
      console.log(`🔍 Buscando tarefa específica ${taskId}...`);
      const filters = { taskId: taskId.toString() };
      const result = await pesquisaApi.getProcessedTasks(1, 1, "", filters);
      
      if (result.tasks && result.tasks.length > 0) {
        const taskData = result.tasks[0];
        console.log(`✅ Tarefa ${taskId} encontrada:`, taskData);
        loadPlanilhaFromDatabase(taskId, taskData);
      } else {
        console.error(`❌ Tarefa ${taskId} não encontrada`);
        alert(`Tarefa #${taskId} não encontrada no banco de dados.`);
      }
    } catch (error) {
      console.error("Erro ao buscar tarefa específica:", error);
    }
  };

  const loadPlanilhaFromDatabase = async (taskId, taskData = null) => {
    if (selectedTaskId === taskId && dataImport) {
      console.log("✅ Tarefa já selecionada");
      return;
    }
    
    setLoadingFile(true);
    setSelectedTaskId(taskId);
    setSelectedTask(taskData || processedTasks.find(t => t.task_id === taskId));
    
    try {
      const blob = await pesquisaApi.getProcessedTaskResult(taskId);
      
      if (!blob || blob.size === 0) {
        alert("Arquivo vazio no banco de dados");
        setDataImport(null);
        return;
      }
      
      const file = new File([blob], `planilha_ref_${taskId}.xlsx`, { 
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
      });
      
      processExcelFile(file, true);
    } catch (error) {
      console.error("Erro ao carregar planilha:", error);
      setDataImport(null);
      alert("Erro ao carregar planilha do banco.");
    } finally {
      setLoadingFile(false);
    }
  };

  const processExcelFile = (file, fromDatabase = false) => {
    setArquivoRef(fromDatabase ? null : file);
    
    var reader = new FileReader();
    reader.readAsArrayBuffer(file);
    
    reader.onload = (e) => {
      try {
        const bufferArray = e.target.result;
        const wb = XLSX.read(bufferArray, { type: "buffer" });
        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];
        const data = XLSX.utils.sheet_to_json(ws);
        let importData = [];
        
        Object.keys(data).forEach((i) => {
          let dados = {};
          Object.keys(data[i]).forEach((j) => {
            dados[j] = data[i][j];
          });
          importData.push(dados);
        });
        
        importData.forEach(item => {
          if (typeof(item["Latitude"]) === 'string') {
            item["Latitude"] = parseFloat(item["Latitude"].replace(',', '.'));
          } 
          if (typeof(item["Longitude"]) === 'string') {
            item["Longitude"] = parseFloat(item["Longitude"].replace(',', '.'));
          }
        });
        
        setDataImport(importData);
      } catch (error) {
        console.error("Erro ao processar Excel:", error);
        setDataImport(null);
      }
    };
  };

  const handleFileUpload = (e) => {
    var file = e.target.files[0];
    if (file) {
      processExcelFile(file);
      setSelectedTaskId("");
      setSelectedTask(null);
    }
  };

  const headersAxiosData = async () => {
    if (!selectedUserId) {
      alert("Por favor, selecione um usuário responsável pela codificação.");
      return;
    }
    
    const data = {
      coding_date: new Date().toLocaleDateString("pt-BR", { timeZone: "UTC" }),
      road_survey_date: new Date().toLocaleDateString("pt-BR", { timeZone: "UTC" }),
      road_name: roadName,
      data_reference_table: JSON.stringify(dataImport),
      section_name: snippet,
      distance: initialKm,
      length: 0.9,
      coder: selectedUserId,
      hasImgs: false
    };
    
    try {
      const res = await pesquisaApi.setHeaders(data);
      const idHead = res.id_header;
      
      if (idHead && dataImport) {
        const dataPayload = {
          dadosTabelaDeReferencia: dataImport,
          idHeader: idHead,
          RoadName: roadName,
          snippet: snippet,
          distance: initialKm,
          coder_id: selectedUserId,
          coder_name: selectedUser?.username || ""
        };
        dispacth(setHeader(dataPayload));
      }
      navigate("/uploadImages");
    } catch(error) {
      console.error("Erro ao salvar header:", error);
      alert(`Erro ao salvar: ${error.response?.data?.detail || error.message}`);
    }
  };

  const onHendlerSave = () => {
    headersAxiosData();
  };

  const isFormComplete = () => {
    if (!roadName || !snippet || initialKm < 0) {
      return false;
    }
    
    if (!selectedUserId) {
      return false;
    }
    
    if (!dataImport || !Array.isArray(dataImport) || dataImport.length === 0) {
      return false;
    }
    
    if (inputMethod === "upload") {
      return !!arquivoRef;
    } else {
      return !!selectedTaskId;
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleRequestSort = (property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSearch = () => {
    setPage(0);
    const filters = {};
    if (taskIdFilter) filters.taskId = taskIdFilter;
    loadProcessedTasks(0, searchText, filters);
  };

  const handleClearFilters = () => {
    setSearchText("");
    setTaskIdFilter("");
    setPage(0);
    loadProcessedTasks(0, "", {});
  };

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('pt-BR') + ' ' + date.toLocaleTimeString('pt-BR', { 
      hour: '2-digit', 
      minute: '2-digit' 
    });
  };

  return (
    <>
      <LateralMenu />
      <Box sx={{ 
          width: "100%", 
          minHeight: "100vh",
          display: "flex", 
          flexDirection: "column", 
          bgcolor: "#e7eaef",
      }}>
      <Container maxWidth="lg" sx={{ p: { xs: 1, sm: 2, md: 3 }, mt: 4, mb: 4, mt: { xs: 6, sm: 8 },  }} >
        
        {/* Cabeçalho do formulário */}
        <Paper  sx={{ 
        p: { xs: 2, sm: 3, md: 4 },
        mx: { xs: 0.5, sm: 0 }
      }} elevation={3}>
          <Typography 
            gutterBottom 
            color="primary" 
            align="center"
            sx={{ fontSize: { xs: '1.5rem', sm: '2rem', md: '2.125rem' } }}
          >
            Selecionar Trecho
          </Typography>
          <Typography variant="body2" color="textSecondary" sx={{ mb: 4 }} align="center">
            Adicione o nome da via, o trecho, o quilômetro inicial e selecione o codificador responsável.
          </Typography>          
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <TextField
                id="roadName"
                label="Nome da Via"
                variant="outlined"
                fullWidth
                value={roadName}
                onChange={(e) => setRoadName(e.target.value)}
                required
              />
            </Grid>
            
            <Grid item xs={12} md={6}>
              <TextField
                id="snippet"
                label="Trecho"
                variant="outlined"
                fullWidth
                value={snippet}
                onChange={(e) => setSnippet(e.target.value)}
                required
              />
            </Grid>
            
            <Grid item xs={12} md={6}>
              <TextField
                id="initialKm"
                label="Km inicial"
                variant="outlined"
                type="number"
                fullWidth
                value={initialKm}
                onChange={(e) => setInitialKm(parseFloat(e.target.value) || 0)}
                inputProps={{ min: 0, step: 0.1 }}
                required
              />
            </Grid>

            {/* Seletor de Usuário Codificador */}
            <Grid item xs={12} md={6}>
              <FormControl fullWidth>
                <InputLabel id="coder-select-label">Codificador Responsável *</InputLabel>
                <Select
                  labelId="coder-select-label"
                  id="coder-select"
                  value={selectedUserId || ''}
                  label="Codificador Responsável *"
                  onChange={(e) => {
                    const userId = e.target.value;
                    setSelectedUserId(userId);
                    const user = users.find(u => u.id === userId);
                    setSelectedUser(user);
                  }}
                  disabled={loadingUsers}
                  required
                >
                  {loadingUsers ? (
                    <MenuItem disabled>
                      <CircularProgress size={20} sx={{ mr: 2 }} />
                      Carregando usuários...
                    </MenuItem>
                  ) : users.length === 0 ? (
                    <MenuItem disabled>Nenhum usuário disponível</MenuItem>
                  ) : (
                    users.map((user) => (
                      <MenuItem key={user.id} value={user.id}>
                        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                          <Typography variant="body1">{user.username}</Typography>
                          <Typography variant="caption" color="text.secondary">
                            {user.email || 'Sem email'}
                            {user.groups && user.groups.length > 0 && (
                              ` • ${user.groups.map(g => g.name).join(', ')}`
                            )}
                          </Typography>
                        </Box>
                      </MenuItem>
                    ))
                  )}
                </Select>
                <FormHelperText>
                  Selecione o usuário responsável pela codificação deste trecho
                </FormHelperText>
              </FormControl>
            </Grid>
          </Grid>

          {/* Seletor de método */}
          <FormControl fullWidth sx={{ mt: 3, mb: 3 }}>
            <InputLabel>Fonte da planilha de referência *</InputLabel>
            <Select
              value={inputMethod}
              onChange={(e) => setInputMethod(e.target.value)}
              label="Fonte da planilha de referência *"
            >
              <MenuItem value="upload">Upload de arquivo Excel</MenuItem>
              <MenuItem value="database">Selecionar do banco de dados</MenuItem>
            </Select>
          </FormControl>

          {/* Upload de arquivo */}
          {inputMethod === "upload" && (
            <>
              <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                {arquivoRef ? (
                  <Alert severity="success" sx={{ flexGrow: 1 }}>
                    Arquivo carregado: {arquivoRef.name}
                  </Alert>
                ) : (
                  <Alert severity="warning" sx={{ flexGrow: 1 }}>
                    Faça upload do arquivo Excel de referência
                  </Alert>
                )}
              </Box>
              
              <Box sx={{ display: "flex", gap: 2 }}>
                <Button
                  variant="contained"
                  component="label"
                  startIcon={<DeleteIcon />}
                >
                  Upload
                  <input 
                    hidden 
                    type="file" 
                    accept=".xlsx,.xls"
                    onChange={handleFileUpload}
                  />
                </Button>
                
                {arquivoRef && (
                  <Button
                    variant="outlined"
                    color="error"
                    startIcon={<DeleteIcon />}
                    onClick={() => {
                      setArquivoRef(null);
                      setDataImport(null);
                    }}
                  >
                    Remover
                  </Button>
                )}
              </Box>
            </>
          )}

          {/* Seleção do banco com paginação */}
          {inputMethod === "database" && (
            <>
              <Paper sx={{ p: 2, mb: 3 }}>
                {/* Barra de busca e filtros */}
                <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
                  <TextField
                    placeholder="Buscar por ID, nome ou arquivo..."
                    variant="outlined"
                    size="small"
                    fullWidth
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                    onKeyPress={(e) => e.key === 'Enter' && handleSearch()}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                  <Tooltip title="Filtros">
                    <IconButton
                      variant="outlined"
                      onClick={() => setShowFilters(!showFilters)}
                      sx={{
                        display: { xs: 'flex', sm: 'none' },
                        border: '1px solid',
                        borderColor: 'divider'
                      }}
                    >
                      <FilterListIcon />
                    </IconButton>
                  </Tooltip>
                  <Button
                    variant="outlined"
                    startIcon={<FilterListIcon />}
                    onClick={() => setShowFilters(!showFilters)}
                    sx={{
                      display: { xs: 'none', sm: 'flex' }
                    }}
                  >
                    Filtros
                  </Button>

                  <Tooltip title="Buscar">
                    <IconButton
                      variant="contained"
                      onClick={handleSearch}
                      color="primary"
                      sx={{
                        display: { xs: 'flex', sm: 'none' }
                      }}
                    >
                      <SearchIcon />
                    </IconButton>
                  </Tooltip>
                  <Button
                    variant="outlined"
                    onClick={handleSearch}
                      sx={{
                        display: { xs: 'none', sm: 'flex' }
                      }}
                  >
                    Buscar
                  </Button>

                  <Tooltip title="Limpar filtros">
                    <IconButton
                      variant="outlined"
                      onClick={handleClearFilters}
                      color="secondary"
                      sx={{
                        display: { xs: 'flex', sm: 'none' },
                        border: '1px solid',
                        borderColor: 'divider'
                      }}
                    >
                      <DeleteIcon />
                    </IconButton>
                  </Tooltip>
                  <Button
                    variant="text"
                    onClick={handleClearFilters}
                    sx={{
                      display: { xs: 'none', sm: 'flex' }
                    }}
                  >
                    Limpar
                  </Button>
                </Box>

                {/* Filtros avançados */}
                {showFilters && (
                  <Box sx={{ display: 'flex', gap: 2, mb: 2, flexWrap: 'wrap' }}>
                    <TextField
                      label="ID da Tarefa"
                      variant="outlined"
                      size="small"
                      value={taskIdFilter}
                      onChange={(e) => setTaskIdFilter(e.target.value)}
                      sx={{ minWidth: 150 }}
                    />
                    
                    <Chip 
                      label={`Ordenação: ${order === 'desc' ? 'Mais recentes' : 'Mais antigas'}`}
                      onDelete={() => handleRequestSort('created_at')}
                    />
                  </Box>
                )}

                {/* Tabela de tarefas */}
                <TableContainer>
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell>
                          <TableSortLabel
                            active={orderBy === 'task_id'}
                            direction={orderBy === 'task_id' ? order : 'asc'}
                            onClick={() => handleRequestSort('task_id')}
                          >
                            ID
                          </TableSortLabel>
                        </TableCell>
                        <TableCell>
                          <TableSortLabel
                            active={orderBy === 'task_name'}
                            direction={orderBy === 'task_name' ? order : 'asc'}
                            onClick={() => handleRequestSort('task_name')}
                          >
                            Nome da Via
                          </TableSortLabel>
                        </TableCell>
                        <TableCell>Arquivo do Eixo</TableCell>
                        <TableCell>
                          <TableSortLabel
                            active={orderBy === 'created_at'}
                            direction={orderBy === 'created_at' ? order : 'asc'}
                            onClick={() => handleRequestSort('created_at')}
                          >
                            Data de Criação
                          </TableSortLabel>
                        </TableCell>
                        <TableCell align="center">Ações</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {loadingTasks ? (
                        <TableRow>
                          <TableCell colSpan={5} align="center">
                            <CircularProgress size={24} />
                            <Typography variant="body2" sx={{ mt: 1 }}>
                              Carregando tarefas...
                            </Typography>
                          </TableCell>
                        </TableRow>
                      ) : processedTasks.length === 0 ? (
                        <TableRow>
                          <TableCell colSpan={5} align="center">
                            <Typography variant="body2" color="text.secondary">
                              Nenhuma tarefa encontrada
                            </Typography>
                          </TableCell>
                        </TableRow>
                      ) : (
                        processedTasks.map((task) => (
                          <TableRow 
                            key={task.task_id}
                            hover
                            selected={selectedTaskId === task.task_id}
                            sx={{ 
                              cursor: 'pointer',
                              backgroundColor: selectedTaskId === task.task_id ? 'action.selected' : 'inherit'
                            }}
                          >
                            <TableCell>
                              <Typography variant="body2" fontWeight="bold">
                                #{task.task_id}
                              </Typography>
                            </TableCell>
                            <TableCell>
                              <Typography variant="body2">
                                {task.task_name || `--`}
                              </Typography>
                            </TableCell>
                            <TableCell>
                              <Typography variant="body2" color="text.secondary" noWrap>
                                {task.axis_file_name.split('_').slice(0, -1).join('_') + ".gpkg" || 'N/A'}
                              </Typography>
                            </TableCell>
                            <TableCell>
                              <Typography variant="body2">
                                {formatDate(task.created_at)}
                              </Typography>
                            </TableCell>
                            <TableCell align="center">
                              <Button
                                size="small"
                                variant={selectedTaskId === task.task_id ? "contained" : "outlined"}
                                disabled={loadingFile && selectedTaskId === task.task_id}
                                onClick={() => loadPlanilhaFromDatabase(task.task_id, task)}
                              >
                                {loadingFile && selectedTaskId === task.task_id ? (
                                  <CircularProgress size={20} />
                                ) : selectedTaskId === task.task_id ? (
                                  "Selecionado"
                                ) : (
                                  "Selecionar"
                                )}
                              </Button>
                            </TableCell>
                          </TableRow>
                        ))
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>

                {/* Paginação */}
                <TablePagination
                  rowsPerPageOptions={[5, 10, 25, 50]}
                  component="div"
                  count={totalTasks}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  labelRowsPerPage="Tarefas por página:"
                  labelDisplayedRows={({ from, to, count }) =>
                    `${from}-${to} de ${count !== -1 ? count : `mais de ${to}`}`
                  }
                />
              </Paper>

              {/* Status da seleção */}
              {selectedTaskId && (
                <Alert 
                  severity={dataImport ? "success" : "info"} 
                  sx={{ mb: 2 }}
                  action={
                    loadingFile ? (
                      <CircularProgress size={20} />
                    ) : null
                  }
                >
                  {dataImport ? (
                    <>
                      <strong>Tarefa #{selectedTaskId} selecionada</strong>
                      <br />
                      {selectedTask?.task_name && `Nome: ${selectedTask.task_name}`}
                      {selectedTask?.axis_file_name && ` | Arquivo: ${selectedTask.axis_file_name.split('_').slice(0, -1).join('_') + ".gpkg"}`}
                      <br />
                      <small>{dataImport.length} registros carregados</small>
                    </>
                  ) : (
                    "Carregando planilha..."
                  )}
                </Alert>
              )}
            </>
          )}
            
            {/* Botão Salvar */}
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
              <ButtonComp 
                disabled={!isFormComplete()} 
                onClick={onHendlerSave}
                size="large"
            >
              Salvar e Continuar
              </ButtonComp>
            </Box>
        </Paper>
      </Container>
      </Box>
    </>
  );
}